import React, { FC, useEffect, useState } from 'react';
import AllPostsTable from '../../components/company/AllPostsTable';
import { JobPostResponse } from '../../types/api';
import jobService from '../../services/job.service';

const AllPosts: FC = () => {
  const [jobPosts, setJobPosts] = useState<JobPostResponse[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAllJobPosts = async () => {
      try {
        const response = await jobService.getAllPosts(1, 100);
        setJobPosts(response.items || []);
      } catch (err) {
        setError('Failed to fetch job posts.');
        console.error('Error fetching job posts:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAllJobPosts();
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">All Job Posts</h1>
      <AllPostsTable jobPosts={jobPosts} isLoading={isLoading} error={error} />
    </div>
  );
};

export default AllPosts;
